import React, {FunctionComponent, useEffect} from "react";
import {RootState} from "../../../Config/Store";
import {useAppSelector} from "../../../Config/Hooks";
import {Container} from "../../../Shared/Components/AlarmTotalizers/AlarmTotalizers.theme";
import {Skeleton, ProgressCard} from "@atiautomacao/ati-ui-library";
import {ACard} from "@atiautomacao/ati-ui-library";
import { Box, Grid } from "@mui/material";
import { TotalizerType } from "../Overview/DashboardOverviewAlarmsPage";
import { useTheme } from "@mui/material";


const TotalizerAlarms: FunctionComponent<{onClickTotalizer:any, clearFilters:boolean}> = ({onClickTotalizer, clearFilters}) => {
    const theme = useTheme();
    
    const bootstrapButton = {
        width: '100%', 
        border: 'none',
        borderStyle: "none",
        background:  'transparent',
        backgroundImage: 'none',
        cursor: 'pointer',
        paddingBottom: '12px',
    };

    const styledTotalizeCard = {
        boxShadow: '0px 2px 4px 0px #00000029',
        borderRadius: '8px',
        '&:hover': {
            boxShadow: '#0062cc',
            transform: 'scale(1.05)',
            transition: "all 0.2s linear"
        }
    };

    const { totalizers, isLoading } = useAppSelector((state: RootState) => state.alarmTotalizers);

    const isLoadingAlarm = useAppSelector((state : RootState) => state.alarmOverview.loading);    
    const [opacityAlarmsSound, setOpacityAlarmsSound] = React.useState(false);
    const [opacityPowerNoCommunication, setOpacityPowerNoCommunication] = React.useState(false);
    const [opacityEquipmentNoCommunication, setOpacityEquipmentNoCommunication] = React.useState(false);
    const [opacityEquipmentAlarm, setOpacityEquipmentAlarm] = React.useState(false);
    const [opacityAlarmCritical, setOpacityAlarmCritical] = React.useState(false);
    const [opacityNotAcknowledged, setOpacityNotAcknowledged] = React.useState(false);
    const [opacityActive, setOpacityActive] = React.useState(false);
    const [valueTotalizerType, setValueTotalizerType] = React.useState<TotalizerType | null>(localStorage.getItem("totalizer_alarm_filter") as TotalizerType ?? "none");
    
    useEffect(() => {
        const totalizer = localStorage.getItem("totalizer_alarm_filter") as TotalizerType;
        if(totalizer){
            setValueTotalizerType(totalizer.toLowerCase() as TotalizerType);
            handleOpacity(totalizer.toLowerCase() as TotalizerType);
        }
    }, []);

    useEffect(() => {
        if(clearFilters){
            setValueTotalizerType("none");
            handleOpacity("none"); // Reseta a opacidade para todos os totalizadores
        }
    }, [clearFilters]);

    const handleOpacity = (type: TotalizerType) => {
        if(type === "alarms_sound"){
            setOpacityAlarmsSound(!opacityAlarmsSound);
        } else if(type === "power_station_no_communication"){
            setOpacityPowerNoCommunication(!opacityPowerNoCommunication);
        } else if(type === "equipment_no_communication"){
            setOpacityEquipmentNoCommunication(!opacityEquipmentNoCommunication);
        } else if(type === "equipments_alarmed"){
            setOpacityEquipmentAlarm(!opacityEquipmentAlarm);
        } else if(type === "active"){
            setOpacityActive(!opacityActive);
        } else if(type === "active_critical"){
            setOpacityAlarmCritical(!opacityAlarmCritical);
        } else if(type === "not_acknowledged"){
            setOpacityNotAcknowledged(!opacityNotAcknowledged);
        }  else if(type === "none"){
            setOpacityPowerNoCommunication(false);
            setOpacityEquipmentNoCommunication(false);
            setOpacityEquipmentAlarm(false);
            setOpacityActive(false);
            setOpacityAlarmCritical(false);
            setOpacityNotAcknowledged(false);
        }
    }

    const handleOnclickByType = (totalizeType: TotalizerType) => {
        localStorage.setItem("totalizer_alarm_filter", totalizeType);
        setValueTotalizerType(totalizeType);
    }

    useEffect(() => {
        if(valueTotalizerType && !isLoadingAlarm){
            onClickTotalizer(valueTotalizerType);
        }

    }, [valueTotalizerType, isLoadingAlarm]);

    if (isLoading) {
        return (
        <Box style={{ marginLeft: -16, marginRight: -16}}>
                <ACard
                    title={"Totalizadores e filtros"}
                    styleProps={{
                        cardStyle: {
                            backgroundColor: 'transparent',
                            backgroundImage: 'none',
                            boxShadow: 'none',
                            border: 'none',
                            borderRadius: 0,
                            padding: 0,
                            paddingBottom: 2,
                        },
                        contentStyle: { padding: 0,
                            marginLeft: '-16px'
                        },
                        headerStyle: {paddingBottom: 0, paddingTop: 0},
                        titleStyle: {fontSize: 16, fontWeight: 'semiBold', paddingBottom: 2}
                    }}
                >
                    <Container data-testid="loading-skeleton">
                        <Skeleton animation="wave" height={70} variant="rectangular" width={200} />
                        <Skeleton animation="wave" height={70} variant="rectangular" width={200} />
                        <Skeleton animation="wave" height={70} variant="rectangular" width={200} />
                        <Skeleton animation="wave" height={70} variant="rectangular" width={200} />
                        <Skeleton animation="wave" height={70} variant="rectangular" width={200} />
                        <Skeleton animation="wave" height={70} variant="rectangular" width={200} />
                        <Skeleton animation="wave" height={70} variant="rectangular" width={200} />
                    </Container>
                </ACard>
            </Box>
        );
    }

    return (
        <Box style={{ marginLeft: -16, marginRight: -16}}>
            <ACard
                title={"Totalizadores e filtros"}
                styleProps={{
                    cardStyle: {backgroundColor: 'transparent', backgroundImage: 'none', boxShadow: 'none', border: 'none', borderRadius: 0, padding: 0},
                    contentStyle: { padding: 0},
                    headerStyle: {paddingBottom: 0, paddingTop: 0},
                    titleStyle: {fontSize: 16, fontWeight: 'semiBold', paddingBottom: 2},
                }}
            >
                <Grid container sx={{marginTop: -4}}>
                <Grid item 
                        xs={12} sm={4} md={4} lg={3} xl={12/7} >
                        <button style={{...bootstrapButton, cursor: valueTotalizerType !== "alarms_sound" && valueTotalizerType !== "none" ? 'not-allowed' : 'pointer'}}
                            onClick={() => {
                                opacityAlarmsSound ? handleOnclickByType("none") : handleOnclickByType("alarms_sound")
                                setOpacityAlarmsSound(!opacityAlarmsSound)
                            }}
                             disabled={valueTotalizerType !== "alarms_sound" && valueTotalizerType !== "none"}
                        >
                            <ProgressCard
                                    valueFontSize={24}
                                    value={totalizers.alarmsSound}
                                    label="Sonoros ativos"
                                    background={valueTotalizerType === "alarms_sound" && opacityAlarmsSound ?  theme.palette.mode === 'light' ? theme.palette.primary.main : theme.palette.grey["A700"] :
                                        theme.palette.mode === 'light' ? '#fff' : '#1E1E1E' }
                                    textColor={valueTotalizerType === "alarms_sound" && opacityAlarmsSound ? '#FFF' : theme.palette.text.primary}
                                    width={'100%'}
                                    showProgressBar={false}
                                    styledPaperProps={{ ...styledTotalizeCard, 
                                        transform: valueTotalizerType === "alarms_sound" && opacityAlarmsSound &&  theme.palette.mode === 'dark' ? 'scale(1.05)': 'scale(1)',
                                        transition: "all 0.2s linear",
                                        opacity: valueTotalizerType === "alarms_sound" && opacityAlarmsSound &&  theme.palette.mode === 'dark' ? 1 : theme.palette.mode === 'dark' ? 0.5 : 1
                                    }}
                            />
                            
                        </button>
                    </Grid>
                    <Grid item 
                        xs={12} sm={4} md={4} lg={3} xl={12/7} >
                        <button style={{...bootstrapButton, cursor: valueTotalizerType !== "power_station_no_communication" && valueTotalizerType !== "none" ? 'not-allowed' : 'pointer'}}
                            onClick={() => {
                                opacityPowerNoCommunication ? handleOnclickByType("none") : handleOnclickByType("power_station_no_communication")
                                setOpacityPowerNoCommunication(!opacityPowerNoCommunication)
                            }}
                             disabled={valueTotalizerType !== "power_station_no_communication" && valueTotalizerType !== "none"}
                        >
                            <ProgressCard
                                    valueFontSize={24}
                                    value={totalizers.powerStationNoCommunication}
                                    label="Usinas s/ com."
                                    background={valueTotalizerType === "power_station_no_communication" && opacityPowerNoCommunication ?  theme.palette.mode === 'light' ? theme.palette.primary.main : theme.palette.grey["A700"] :
                                        theme.palette.mode === 'light' ? '#fff' : '#1E1E1E' }
                                    textColor={valueTotalizerType === "power_station_no_communication" && opacityPowerNoCommunication ? '#FFF' : theme.palette.text.primary}
                                    width={'100%'}
                                    showProgressBar={false}
                                    styledPaperProps={{ ...styledTotalizeCard, 
                                        transform: valueTotalizerType === "power_station_no_communication" && opacityPowerNoCommunication &&  theme.palette.mode === 'dark' ? 'scale(1.05)': 'scale(1)',
                                        transition: "all 0.2s linear",
                                        opacity: valueTotalizerType === "power_station_no_communication" && opacityPowerNoCommunication &&  theme.palette.mode === 'dark' ? 1 : theme.palette.mode === 'dark' ? 0.5 : 1
                                    }}
                            />
                            
                        </button>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4} lg={3} xl={12/7} >
                        <button style={{...bootstrapButton, cursor: valueTotalizerType !== "equipment_no_communication" && valueTotalizerType !== "none" ? 'not-allowed' : 'pointer'}}
                            onClick={() => {
                                opacityEquipmentNoCommunication ? handleOnclickByType("none") : handleOnclickByType("equipment_no_communication")
                                setOpacityEquipmentNoCommunication(!opacityEquipmentNoCommunication)
                                
                            }}
                             disabled={valueTotalizerType !== "equipment_no_communication" && valueTotalizerType !== "none"}
                        >
                            <ProgressCard
                                valueFontSize={24}
                                value={totalizers.equipmentsNoCommunication}
                                label="Equipamentos s/ com."
                                background={valueTotalizerType === "equipment_no_communication" && opacityEquipmentNoCommunication ?
                                    theme.palette.mode === 'light' ? theme.palette.primary.main : theme.palette.grey["A700"] :  theme.palette.mode === 'light' ? '#FFF' : '#1E1E1E' }
                                textColor={valueTotalizerType === "equipment_no_communication" && opacityEquipmentNoCommunication ? '#FFF' : theme.palette.text.primary}
                                width={'100%'}
                                showProgressBar={false}
                                styledPaperProps={{...styledTotalizeCard,
                                    transform: valueTotalizerType === "equipment_no_communication" && opacityEquipmentNoCommunication &&  theme.palette.mode === 'dark' ? 'scale(1.05)': 'scale(1)',
                                    transition: "all 0.2s linear",
                                    opacity: valueTotalizerType === "equipment_no_communication" && opacityEquipmentNoCommunication &&  theme.palette.mode === 'dark' ? 1 : theme.palette.mode === 'dark' ? 0.5 : 1
                                }}
                            />
                        </button>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4} lg={3} xl={12/7} >
                        <button style={{...bootstrapButton, cursor: valueTotalizerType !== "equipments_alarmed" && valueTotalizerType !== "none" ? 'not-allowed' : 'pointer'}}
                            onClick={() => {
                                opacityEquipmentAlarm ? handleOnclickByType("none") : handleOnclickByType("equipments_alarmed")
                                setOpacityEquipmentAlarm(!opacityEquipmentAlarm)
                            }}
                           disabled={valueTotalizerType !== "equipments_alarmed" && valueTotalizerType !== "none"}
                        >
                            <ProgressCard
                                valueFontSize={24}
                                value={totalizers.equipmentsAlarmed}
                                label="Equipamentos alarmados"
                                background={valueTotalizerType === "equipments_alarmed" && opacityEquipmentAlarm ? theme.palette.mode === 'light' ? theme.palette.primary.main : theme.palette.grey["A700"] :  theme.palette.mode === 'light' ? '#fff' : '#1E1E1E' }
                                textColor={valueTotalizerType === "equipments_alarmed" && opacityEquipmentAlarm ?  '#FFF' : theme.palette.text.primary}
                                width={'100%'}
                                showProgressBar={false}
                                styledPaperProps={{...styledTotalizeCard,
                                    transform: valueTotalizerType === "equipments_alarmed" && opacityEquipmentAlarm &&  theme.palette.mode === 'dark' ? 'scale(1.05)': 'scale(1)',
                                    transition: "all 0.2s linear",
                                    opacity: valueTotalizerType === "equipments_alarmed" && opacityEquipmentAlarm &&  theme.palette.mode === 'dark' ? 1 : theme.palette.mode === 'dark' ? 0.5 : 1}}
                            />
                        </button>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4} lg={3} xl={12/7} >
                        <button style={{...bootstrapButton, cursor: valueTotalizerType !== "active" && valueTotalizerType !== "none" ? 'not-allowed' : 'pointer'}}
                            onClick={() => {
                                opacityActive ? handleOnclickByType("none") : handleOnclickByType("active")
                                setOpacityActive(!opacityActive)
                            }}
                             disabled={valueTotalizerType !== "active" && valueTotalizerType !== "none"}
                        >
                            <ProgressCard
                                valueFontSize={24}
                                value={totalizers.active}
                                label="Alarmes ativos"
                                background={valueTotalizerType === "active" && opacityActive ? theme.palette.mode === 'light' ? theme.palette.primary.main : theme.palette.grey["A700"] :  theme.palette.mode === 'light' ? '#fff' : '#1E1E1E' }
                                textColor={valueTotalizerType === "active" && opacityActive ?  '#FFF' : theme.palette.text.primary}
                                width={'100%'}
                                showProgressBar={false}
                                styledPaperProps={{...styledTotalizeCard,
                                    transform: valueTotalizerType === "active" && opacityActive &&  theme.palette.mode === 'dark' ? 'scale(1.05)': 'scale(1)',
                                    transition: "all 0.2s linear",
                                    opacity: valueTotalizerType === "active" && opacityActive &&  theme.palette.mode === 'dark' ? 1 : theme.palette.mode === 'dark' ? 0.5 : 1
                                }}
                            />
                        </button>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4} lg={3} xl={12/7} >
                        <button style={{...bootstrapButton, cursor: valueTotalizerType !== "active_critical" && valueTotalizerType !== "none" ? 'not-allowed' : 'pointer'}}
                            onClick={() => {
                                opacityAlarmCritical ? handleOnclickByType("none") : handleOnclickByType("active_critical")
                                setOpacityAlarmCritical(!opacityAlarmCritical)
                            }}
                             disabled={valueTotalizerType !== "active_critical" && valueTotalizerType !== "none"}
                        >
                            <ProgressCard
                                valueFontSize={24}
                                value={totalizers.activeCritical}
                                label="Críticos ativos"
                                background={valueTotalizerType === "active_critical" && opacityAlarmCritical ? theme.palette.mode === 'light' ? theme.palette.primary.main : theme.palette.grey["A700"] :  theme.palette.mode === 'light' ? '#fff' : '#1E1E1E' }
                                textColor={valueTotalizerType === "active_critical" && opacityAlarmCritical ?  '#FFF' : theme.palette.text.primary}
                                width={'100%'}
                                showProgressBar={false}
                                styledPaperProps={{...styledTotalizeCard,
                                    transform: valueTotalizerType === "active_critical" && opacityAlarmCritical &&  theme.palette.mode === 'dark' ? 'scale(1.05)': 'scale(1)',
                                    transition: "all 0.2s linear",
                                    opacity: valueTotalizerType === "active_critical" && opacityAlarmCritical &&  theme.palette.mode === 'dark' ? 1 : theme.palette.mode === 'dark' ? 0.5 : 1
                                }}
                            />
                        </button>
                    </Grid>
                    <Grid item xs={12} sm={4} md={4} lg={3} xl={12/7} paddingRight={'16px'}>
                        <button style={{...bootstrapButton, cursor: valueTotalizerType !== "not_acknowledged" && valueTotalizerType !== "none" ? 'not-allowed' : 'pointer'}}
                            onClick={() => {
                                opacityNotAcknowledged ? handleOnclickByType("none") : handleOnclickByType("not_acknowledged")
                                setOpacityNotAcknowledged(!opacityNotAcknowledged)
                            }}
                             disabled={valueTotalizerType !== "not_acknowledged" && valueTotalizerType !== "none"}
                        >
                            <ProgressCard
                                valueFontSize={24}
                                value={totalizers.notAcknowledged}
                                label="Não reconhecidos"
                                background={valueTotalizerType === "not_acknowledged" && opacityNotAcknowledged ? theme.palette.mode === 'light' ? theme.palette.primary.main : theme.palette.grey["A700"] :  theme.palette.mode === 'light' ? '#fff' : '#1E1E1E' }
                                textColor={valueTotalizerType === "not_acknowledged" && opacityNotAcknowledged ?  '#FFF' : theme.palette.text.primary}
                                width={'100%'}
                                showProgressBar={false}
                                styledPaperProps={{...styledTotalizeCard,
                                    transform: valueTotalizerType === "not_acknowledged" && opacityNotAcknowledged &&  theme.palette.mode === 'dark' ? 'scale(1.05)': 'scale(1)',
                                    transition: "all 0.2s linear",
                                    opacity: valueTotalizerType === "not_acknowledged" && opacityNotAcknowledged &&  theme.palette.mode === 'dark' ? 1 : theme.palette.mode === 'dark' ? 0.5 : 1
                                }}
                            />
                        </button>
                      
                    </Grid>
                </Grid>
            </ACard>
        </Box>
    )

}   

export default TotalizerAlarms;
